import schema from './schema.js'
import editPagePageConfig from './editPage/pageConfig.js'
import listPagePageConfig from './listPage/pageConfig.js'

export default {
  title: '零售結帳',
  schema,
  edit: editPagePageConfig,
  list: listPagePageConfig,
}
